__turbopack_context__.v({
  "className": "heebo_c205be5d-module__fgl03W__className",
});
